import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Navbar from './Navbar'
import Footer from './Footer'
import CookieBanner from './CookieBanner'
import { API_BASE_URL } from '../config/api'

export default function Layout() {
  const { pathname } = useLocation()

  useEffect(() => {
    if (pathname.startsWith('/dashboard')) return
    const base = API_BASE_URL.endsWith('/') ? API_BASE_URL.slice(0, -1) : API_BASE_URL
    const url = `${base}/analytics/ping?path=${encodeURIComponent(pathname)}`
    fetch(url, { method: 'GET', keepalive: true }).catch(() => {})
  }, [pathname])

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  )
}

















